import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { updates } from "@/mocks/siteData";

const tagTabs = ["全部", "功能", "体验", "说明", "内容"] as const;

const tagStyle: Record<string, string> = {
  功能: "bg-primary-100 text-primary-800",
  体验: "bg-accent-100 text-accent-900",
  说明: "bg-secondary-100 text-secondary-800",
  内容: "bg-background-200 text-foreground-700",
};

export default function Updates() {
  const [tag, setTag] = useState<string>("全部");
  const list = updates.filter((u) => tag === "全部" || u.tag === tag);

  return (
    <section id="updates" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
                <span className="w-6 h-px bg-primary-400"></span>
                更新动态
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                最近的整理与调整记录
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                页面结构与说明会随着片单一起调整。下面按时间倒序记录了最近的改动，可以按类型筛选，
                快速了解哪个方向有更新。
              </p>
            </div>
            <div className="shrink-0 flex flex-wrap items-center gap-1 p-1 rounded-full bg-background-200/60 border border-background-200">
              {tagTabs.map((t) => (
                <button
                  key={t}
                  onClick={() => setTag(t)}
                  className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm transition-colors cursor-pointer whitespace-nowrap ${
                    tag === t ? "bg-secondary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-12 relative">
          <span className="hidden md:block absolute left-[7.5rem] top-2 bottom-2 w-px bg-background-300" aria-hidden="true"></span>
          <div className="space-y-5">
            {list.map((u, idx) => (
              <Reveal key={u.title} delay={Math.min(idx, 5) * 50}>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 items-start">
                  <div className="md:col-span-2 flex md:justify-end md:pr-6 items-center gap-2">
                    <span className="md:hidden w-2 h-2 rounded-full bg-primary-500"></span>
                    <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{u.date}</span>
                  </div>
                  <div className="hidden md:flex md:col-span-1 justify-center relative">
                    <span className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100 relative z-10 mt-1.5"></span>
                  </div>
                  <div className="md:col-span-9 bg-background-50 rounded-lg border border-background-200 p-5 md:p-6">
                    <div className="flex items-center gap-3 flex-wrap">
                      <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${tagStyle[u.tag] ?? tagStyle["内容"]}`}>
                        {u.tag}
                      </span>
                      <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{u.title}</h3>
                    </div>
                    <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{u.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}